import { render, staticRenderFns } from "./LeavesDataTable.vue?vue&type=template&id=d5f49e32"
import script from "./LeavesDataTable.vue?vue&type=script&lang=js"
export * from "./LeavesDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports